/**
 * @generated SignedSource<<47ac3afcafc0f594640677abd30840ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CancelClassExitSlipInput = {
  classExitSlipId: string;
};
export type ExitSlipCancelClassExitSlipMutation$variables = {
  input: CancelClassExitSlipInput;
};
export type ExitSlipCancelClassExitSlipMutation$data = {
  readonly cancelClassExitSlip: {
    readonly classExitSlipNode: {
      readonly canceledOn: any | null | undefined;
      readonly dueOn: any;
      readonly id: string;
    } | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null | undefined;
  };
};
export type ExitSlipCancelClassExitSlipMutation = {
  response: ExitSlipCancelClassExitSlipMutation$data;
  variables: ExitSlipCancelClassExitSlipMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ClassExitSlipNode",
  "kind": "LinkedField",
  "name": "classExitSlipNode",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dueOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canceledOn",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "UnauthorizedAccessError",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "InvalidIdsError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipCancelClassExitSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CancelClassExitSlipPayload",
        "kind": "LinkedField",
        "name": "cancelClassExitSlip",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipCancelClassExitSlipMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CancelClassExitSlipPayload",
        "kind": "LinkedField",
        "name": "cancelClassExitSlip",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d8b591d58f44cc007fb6f868b5fc2f27",
    "id": null,
    "metadata": {},
    "name": "ExitSlipCancelClassExitSlipMutation",
    "operationKind": "mutation",
    "text": "mutation ExitSlipCancelClassExitSlipMutation(\n  $input: CancelClassExitSlipInput!\n) {\n  cancelClassExitSlip(input: $input) {\n    classExitSlipNode {\n      id\n      dueOn\n      canceledOn\n    }\n    errors {\n      __typename\n      ... on UnauthorizedAccessError {\n        message\n      }\n      ... on InvalidIdsError {\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44e3adf0df09071662735b8b01de2e88";

export default node;
